<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Attachment Warning</v-card-title>


        <v-card-text>
            <div
                v-if="has_spreadsheet"
            >
                <p>You have one or more attachments that are spreadsheet files.  Are you <b>sure</b> that you want to send these files to all recipients?</p>

                <v-checkbox
                    v-model="confirm_spreadsheet"
                    label="I intend to send these spreadsheet(s) to all recipients"
                />
                
            </div>

            <div
                v-if="has_gif"
            >
                <p>You have one or more attachments that are GIF files.</p>
                <p>In our experience, GIF file(s) can cause serious deliverability issues with several mobile carriers.  These files are problematic when used in bulk messages and we do not recommend sending them.</p>

                <v-checkbox
                    v-model="confirm_gif"
                    label="I wish to use GIF file(s) in my bulk message"
                />
                
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Use the attachement(s) 
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            meta_data: [],
            on_confirm: null,
            on_abandon: null,

            confirm_spreadsheet: false,
            confirm_gif: false,
        }
    },

    methods: {

        showDialog(meta_data, on_confirm, on_abandon)
        {
            this.meta_data = meta_data;
            this.on_confirm = on_confirm;
            this.on_abandon = on_abandon;

            this.confirm_spreadsheet = false;
            this.confirm_gif = false;

            if ( this.is_valid )
            {
                on_confirm();
                return;
            }

            // If here, then we need a confirmation
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.on_confirm();
        },

        onCancel()
        {
            this.dialog = false;
            this.on_abandon();
        },

    },

    computed: {
        has_spreadsheet() {
            for ( let i = 0; i < this.meta_data.length; i++ )
            {
                let content_type = this.meta_data[i].content_type;

                if ( content_type.toLowerCase() == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'.toLowerCase() ) return true;
                if ( content_type.toLowerCase() == 'application/vnd.ms-excel.sheet.binary.macroEnabled'.toLowerCase() ) return true;
                if ( content_type.toLowerCase() == 'application/vnd.ms-excel'.toLowerCase() ) return true;
                if ( content_type.toLowerCase() == 'application/vnd.ms-excel.sheet.macroEnabled'.toLowerCase() ) return true;
                if ( content_type.toLowerCase() == 'text/csv'.toLowerCase() ) return true;
                if ( content_type.toLowerCase() == 'application/csv'.toLowerCase() ) return true;
            }

            return false;
        },

        has_gif() {
            for ( let i = 0; i < this.meta_data.length; i++ )
            {
                let content_type = this.meta_data[i].content_type;

                if ( content_type.toLowerCase().includes('image/gif') ) return true;
            }

            return false;
        },

        is_valid() {
            if ( this.has_spreadsheet && !this.confirm_spreadsheet ) return false;
            if ( this.has_gif && !this.confirm_gif ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>